var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 3.94975C14.175 4.16702 13.6483 4.31383 13.0946 4.38018C13.6595 4.04195 14.0928 3.50523 14.2972 2.86634C13.7687 3.17991 13.1832 3.40775 12.5602 3.5299C12.0611 2.99905 11.3505 2.66669 10.5637 2.66669C9.05334 2.66669 7.8284 3.89162 7.8284 5.40312C7.8284 5.61686 7.85307 5.82474 7.89887 6.02556C5.62458 5.91106 3.60984 4.82177 2.26042 3.167C2.02553 3.57217 1.89047 4.04195 1.89047 4.54226C1.89047 5.4912 2.37375 6.32916 3.10719 6.81948C2.65855 6.8048 2.23693 6.68207 1.86816 6.47713V6.51237C1.86816 7.83771 2.81064 8.94344 4.06259 9.19477C3.8324 9.25702 3.59105 9.2899 3.34207 9.2899C3.16591 9.2899 2.99385 9.27346 2.82708 9.24175C3.1753 10.3281 4.18532 11.1197 5.38265 11.1408C4.44604 11.8748 3.26632 12.3123 1.98502 12.3123C1.76422 12.3123 1.54637 12.2994 1.33203 12.2741C2.54287 13.051 3.98038 13.5032 5.52476 13.5032C10.5572 13.5032 13.3083 9.33512 13.3083 5.72021C13.3083 5.60277 13.3054 5.48415 13.3001 5.36671C13.8345 4.98032 14.2984 4.49939 14.6642 3.95152L14.6654 3.94975Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.414544e0384fe1384498420f34c48acb.svg";
export { ForwardRef as ReactComponent };